module.exports = __webpack_public_path__ + "static/media/home-logixtal.3a7d9383.jpg";